<template>
    <div>
        <action-finance-account-movement-reprocess></action-finance-account-movement-reprocess>
        <action-franchise-payment-create></action-franchise-payment-create>
        <action-franchise-referral-create></action-franchise-referral-create>
    </div>
</template>

<script>

import ActionFinanceAccountMovementReprocess from './ActionFinanceAccountMovementReprocess.vue'
import ActionFranchisePaymentCreate from './ActionFranchisePaymentCreate.vue'
import ActionFranchiseReferralCreate from './ActionFranchiseReferralCreate.vue'

export default {
    components: {
        ActionFinanceAccountMovementReprocess,
        ActionFranchisePaymentCreate,
        ActionFranchiseReferralCreate
    },
    data: () => {
        return {
            
        }
    },
    methods: {
       
    },
    mounted: function() {
    }
}

</script>